import React from 'react';
import { Link, browserHistory } from 'react-router';
import {
  NoiDungKienNghi
} from './sub-view';
import { Collapse } from '@blueprintjs/core';
import moment from 'moment';
import { ContainerFileDinhKem } from 'components/upload';
import { TextMessage, Text } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { RowItemChiTietThanhVienCuocThanhTraView } from 'modules/thanh-tra/datatable';
import { ThanhTra } from 'api';
import { get, isEmpty } from 'lodash';
import { Toastr } from 'modules/toastr';
import { RowItemCanCuCuocThanhTraView } from '../thanh-tra/datatable';
import { ChiTietDoiTuongThanhTraDialog } from 'modules/dialog';

class KetQuaTheoDoiThucHien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataDetail: [],
      id: this.props.params.id,
      showFile: false,
      listDoiTuongViPham: [],
      dataDonViBanHanh: [],
      type: this.props.type,
      showDoiTuongThanhTra: false,
      showThongTinThanhTra: true,
      showThongTinTheoDoi: true,
      enableKetThuc: false,
      // value
      soVanBanChiDaoCuaCapTren: '',
      coQuanBanHanhChiDaoCuaCapTren: '',
      ghiChuVanBanChiDaoCuaCapTren: '',
      ngayBanHanhVanBanChiDaoCuaCapTren: '',

      soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: '',
      ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: '',

      // list tai lieu

      listTaiLieuChiDaoCuaCapTren: [],
      listTaiLieuKetQuaThucHienKetLuanThanhTra: [],
      listTaiLieuXuLyCuocThanhTra: [],
      dataCanCuThanhTraLai: [],

      listTaiLieuVanThuThanhTra: [],
      listTaiLieuVanThuThanhTraView: [],
      chiTietDT: false
    }
  }

  componentDidMount() {
    this.getDetail(this.state.id);
    this.getDonViBanHanh();
    this.getDataCanCuThanhTraLai();
  }

  getDataCanCuThanhTraLai() {
    ThanhTra.actions.getCanCuThanhTraLai.request().then(res => {
      if (res.data) {
        this.setState({
          dataCanCuThanhTraLai: res.data
        })
      }
    })
  }

  getCanCuThanhTraLai(value) {
    if (this.state.dataCanCuThanhTraLai.length > 0) {
      return this.state.dataCanCuThanhTraLai[this.state.dataCanCuThanhTraLai.findIndex(x => x.giaTri == value)].ten
    } else {
      return
    }
  }

  checkListDoiTuongViPham() {
    let Data = this.state.dataDetail;
    let listDoiTuongViPham = [];
    let doiTuongThanhTraLienQuan = [];
    let doiTuongThanhTras = [...Data.listDoiTuongThanhTra];
    let doiTuongThanhTra = Data.doiTuongThanhTraInfo;
    let data = Data.doiTuongThanhTraLienQuan.split('; ');
    if (data.length > 0) {
      data.map(state => {
        if (state) {
          doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
            ten: state
          }
        }
      })
    }
    if (doiTuongThanhTraLienQuan.length > 0) {
      doiTuongThanhTraLienQuan.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTras.length > 0) {
      doiTuongThanhTras.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTra) {
      listDoiTuongViPham[listDoiTuongViPham.length] = {
        ten: doiTuongThanhTra.ten,
        giaTri: doiTuongThanhTra.ten
      }
    }
    this.setState({
      listDoiTuongViPham: listDoiTuongViPham
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.params.id,
      type: nextProps.type
    })
  }

  getDetail(id) {
    ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        this.setState({
          dataDetail: res.data,
          soVanBanChiDaoCuaCapTren: res.data.soVanBanChiDaoCuaCapTren ? res.data.soVanBanChiDaoCuaCapTren : '',
          coQuanBanHanhChiDaoCuaCapTren: res.data.coQuanBanHanhChiDaoCuaCapTren ? res.data.coQuanBanHanhChiDaoCuaCapTren : '',
          ghiChuVanBanChiDaoCuaCapTren: res.data.ghiChuVanBanChiDaoCuaCapTren ? res.data.ghiChuVanBanChiDaoCuaCapTren : '',
          ngayBanHanhVanBanChiDaoCuaCapTren: res.data.ngayBanHanhVanBanChiDaoCuaCapTren ? moment(res.data.ngayBanHanhVanBanChiDaoCuaCapTren).format('DD/MM/YYYY') : '',

          soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
          coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra : '',
          ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra: res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra ? res.data.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra : '',
          ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT: res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT ? moment(res.data.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT).format('DD/MM/YYYY') : '',
        }, () => {
          this.checkListDoiTuongViPham();
        })
      }
    })
    this.getChiTietLienQuanCuocThanhTra(id);
  }

  getChiTietLienQuanCuocThanhTra(id) {
    ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let Data = res.data;
        this.state.listTaiLieuChiDaoCuaCapTren = Data.listTaiLieuChiDaoCuaCapTren ? Data.listTaiLieuChiDaoCuaCapTren : [];
        this.state.listTaiLieuKetQuaThucHienKetLuanThanhTra = Data.listTaiLieuKetQuaThucHienKetLuanThanhTra ? Data.listTaiLieuKetQuaThucHienKetLuanThanhTra : [];
        this.state.listTaiLieuXuLyCuocThanhTra = Data.listTaiLieuXuLyCuocThanhTra ? Data.listTaiLieuXuLyCuocThanhTra : [];
        this.setState({
          ...this.state
        }, () => {
          this.setState({
            showFile: true
          })
        })
      }
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime >= secondTime && type == 'show') {
      return true
    } else {
      return false
    }
  }


  getDonViBanHanh() {
    ThanhTra.actions.getListDonViBanHanh.request().then(res => {
      if (res.data) {
        this.setState({
          dataDonViBanHanh: res.data
        })
      }
    })
  }

  handleCollapse(name) {
    this.setState({
      [name]: !this.state[name]
    })
  }

  onClickClose() {
    browserHistory.goBack();
  }

  onOpenDialog() {
    this.setState({
      chiTietDT: true
    });
  }

  toggleDialog() {
    this.setState({
      chiTietDT: false
    });
  }


  render() {
    let Data = this.state.dataDetail;
    let DataDetail = this.state.dataDetail;

    let DoiTuongThanhTra = '';
    let tenDoiTuongThanhTraTKH = '';
    let CountDoiTuongThanhTra = 0;
    let CountDonViPhoiHop = 0;
    let CountDoiTuongThanhTraLienQuan = 0;
    if (Data && Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      tenDoiTuongThanhTraTKH = Data.listDoiTuongThanhTra[0].ten;
    } else if (Data && Data.cuocThanhTraNhieuDoiTuong && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      tenDoiTuongThanhTraTKH = `${Data.listDoiTuongThanhTra.length} đối tượng`;
    }
    if (Data.donViPhoiHop) {
      CountDonViPhoiHop = Data.donViPhoiHop.split('; ').length
    }
    if (Data.doiTuongThanhTraLienQuan) {
      CountDoiTuongThanhTraLienQuan = Data.doiTuongThanhTraLienQuan.split('; ').length
    }

    if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      Data.listDoiTuongThanhTra.map((state, index) => {
        if (index == 0) {
          DoiTuongThanhTra = DoiTuongThanhTra + state.ten;
        } else {
          DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
        }
      })
      CountDoiTuongThanhTra = Data.listDoiTuongThanhTra.length
    }
    let data = [...this.state.dataDonViBanHanh]
    let dataFilter = data.filter(state => {
      return state.giaTri == Data.donViBanHanh
    })
    let donViBanHanh = '';
    if (dataFilter.length > 0) {
      donViBanHanh = dataFilter[0].ten
    }

    let dataVanBanChiDao = [...this.state.dataDonViBanHanh]
    let dataVanBanChiDaoFilter = dataVanBanChiDao.filter(state => {
      return state.giaTri == Data.coQuanBanHanhChiDaoCuaCapTren
    })
    let donViBanHanhVanBanChiDao = '';
    if (dataVanBanChiDaoFilter.length > 0) {
      donViBanHanhVanBanChiDao = dataVanBanChiDaoFilter[0].ten
    }

    let dataVanBanBaoCao = [...this.state.dataDonViBanHanh]
    let dataVanBanBaoCaoFilter = dataVanBanBaoCao.filter(state => {
      return state.giaTri == Data.coQuanBanHanhBaoCaoKetQuaThucHienKetLuanThanhTra
    })
    let donViBanHanhVanBanBaoCao = '';
    if (dataVanBanBaoCaoFilter.length > 0) {
      donViBanHanhVanBanBaoCao = dataVanBanBaoCaoFilter[0].ten
    }
    const isKiemTra = get(DataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
    const loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
    const keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
    return (
      <div className="center reception-container wrap-block">
        <div className="back-foward">
          <Link onClick={this.onClickClose.bind(this, 'close')} title="">Về trang trước</Link>
        </div>
        <div className="heading with-right-content">
          <h2 className="heading-title icon-add">
            Thông tin chi tiết theo dõi thực hiện sau {loaiCuocText}
          </h2>
          <ShowIf condition={get(DataDetail, 'tienDoThanhTra') == 'LUU_HO_SO'}>
            <p className='heading-code' onClick={() => {
              navigator.clipboard.writeText(get(DataDetail, 'hoSoThanhTra.maHoSo') || '');
              Toastr('Copy mã hồ sơ thành công.', 'success');
            }}>{get(DataDetail, 'hoSoThanhTra.maHoSo')}<span className='tt-copy'></span></p>
          </ShowIf>
        </div>
        <div className="bottom-content">
          <h2 className={`collapse-title pl20 pr20 pt20 ${this.state.showThongTinThanhTra ? "collapse-open" : "collapse-close"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showThongTinThanhTra')}>1. Thông tin {loaiCuocText}</Link></h2>
          <div className='pl20 pr20 pt20'>
            <div className='line-border'></div>
          </div>
          <ShowIf condition={DataDetail.keHoachThanhTraInfo !== null}>
            {/*thông tin cuộc thanh tra/kiểm tra*/}
            <section className='wrap-block'>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>1.1. Thông tin kế hoạch {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${loaiCuocText}:`} className='col-20' value={`Kế hoạch thanh tra/kiểm tra năm ${DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : ''}`} />
                <Text label={`Quyết định phê duyệt ${keHoachText}:`} className='col-20' value={DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : ''} />
                <Text label='Ngày phê duyệt:' className='col-20' value={DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? moment(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label='Người ký:' className='col-20' value={DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.nguoiKy : ''} />
              </div>
            </section>
            {/*end thông tin cuộc thanh tra/kiểm tra*/}
            <div className='mt10 pl20 pr20'>
              <div className='line-border'></div>
            </div>
          </ShowIf>
          {/*thông tin cuộc thanh tra/kiểm tra*/}
          <section className='wrap-block'>
            <ShowIf condition={DataDetail.keHoachThanhTraInfo === null}>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>1.1. Thông tin cuộc {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${loaiCuocText}:`} className='col-25 mb10' value={Data.namThanhTra ? Data.namThanhTra : ''} />
                <Text link label={`Đối tượng ${loaiCuocText}:`} className='col-75 mb10' onClick={this.onOpenDialog.bind(this)} value={tenDoiTuongThanhTraTKH} />
                <Text label={`Tên cuộc ${loaiCuocText}:`} className='col-100 mb10' value={Data.ten ? Data.ten : ''} />
                <Text label={`Thời kỳ ${loaiCuocText}:`} className='col-25 mb10' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <TextMessage label={`Nội dung ${loaiCuocText}:`} className='col-100 mb10' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} />
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Số quyết định về việc ${loaiCuocText}:`} className='col-25 mb10' value={Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : ''} />
                <Text label='Ngày ra quyết định:' className='col-25 mb10' value={Data.ngayRaQuyetDinh ? moment(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label='Loại hình:' value={Data.loaiHinhThanhTraInfo ? Data.loaiHinhThanhTraInfo.text : ''} className='col-25 mb10' />
                <ShowIf condition={Data.loaiHinhThanhTra == 'THANH_TRA_LAI'}>
                  <Text label={`Căn cứ ${loaiCuocText} lại:`} value={Data.canCuThanhTraLai ? this.getCanCuThanhTraLai(Data.canCuThanhTraLai) : ''} className='col-100 mb10' />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Ngày công bố QĐ ${loaiCuocText}:`} className='col-25 mb10' value={Data.ngayCongBoQuyetDinhThanhTra ? moment(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : ''} />
                <Text label={`Thời hạn ${loaiCuocText} (ngày làm việc):`} type='sdt' className='col-25 mb10' value={`${Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0} ngày (${Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''})`} />
                <Text label='Hình thức:' className='col-25 mb10' value={Data.hinhThucThanhTraInfo ? Data.hinhThucThanhTraInfo.text : ''} />
                <ShowIf condition={Data.hinhThucThanhTra == 'DOT_XUAT'}>
                  <TextMessage label={`Căn cứ ${loaiCuocText} đột xuất:`} className='col-100 mb10' value={Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : ''} />
                </ShowIf>
              </div>
              <Collapse className="wrap-collapses" isOpen={this.state.showThongTinThanhTra}>
                <div className='row pl30 pr30'>
                  <Text label={`Chức năng ${loaiCuocText}:`} className='col-25 mb10' value={Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : ''} />
                  <ShowIf condition={Data.chucNangCuocThanhTra == 'HANH_CHINH'}>
                    <Text label={`Lĩnh vực ${loaiCuocText}:`} className='col-25 mb10' value={!isEmpty(Data, 'linhVucThanhTraList') ? get(Data, 'linhVucThanhTraList', []).map((item) => item.text).join(', ') : ''} />
                  </ShowIf>
                  <ShowIf condition={DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH'}>
                    <Text label={`Hình thức ${loaiCuocText} chuyên ngành:`} className='col-25 mb10' value={Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : ''} />
                  </ShowIf>
                </div>
                {/* <div className='row pl30 pr30'>
                    <Text label='Đơn vị chủ trì:' className='col-25 mb10' value={Data.donViChuTriInfo ? Data.donViChuTriInfo.ten : ''}/>
                  </div> */}
              </Collapse>
            </ShowIf>

            <ShowIf condition={DataDetail.keHoachThanhTraInfo !== null}>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>1.2. Thông tin cuộc {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text link label={`Đối tượng ${loaiCuocText}:`} className='col-25 mb10' onClick={this.onOpenDialog.bind(this)} value={tenDoiTuongThanhTraTKH} />
                <Text label={`Thời kỳ ${loaiCuocText}:`} className='col-25 mb10' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <Text label={`Tên cuộc ${loaiCuocText}:`} className='col-100 mb10' value={Data.ten ? Data.ten : ''} />
                <TextMessage label={`Nội dung ${loaiCuocText}:`} className='col-100 mb10' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} />
              </div>
            </ShowIf>
          </section>
          <section className='wrap-block mb10'>
            <ShowIf condition={DataDetail.keHoachThanhTraInfo !== null}>
              <div className='row pl30 pr30'>
                <Text label={`Số quyết định về việc ${loaiCuocText}:`} className='col-25 mb10' value={Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : ''} />
                <Text label='Ngày ra quyết định:' className='col-25 mb10' value={Data.ngayRaQuyetDinh ? moment(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label={`Ngày công bố QĐ ${loaiCuocText}:`} className='col-25 mb10' value={Data.ngayCongBoQuyetDinhThanhTra ? moment(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : ''} />
                <Text label={`Thời hạn ${loaiCuocText} (ngày làm việc):`} type='sdt' className='col-25 mb10' value={`${Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0} ngày (${Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''})`} />
              </div>
            </ShowIf>
            <Collapse className="wrap-collapses" isOpen={this.state.showThongTinThanhTra}>
              <div className='row pl30 pr30'>
                <ShowIf condition={DataDetail.keHoachThanhTraInfo !== null}>
                  <Text label={`Chức năng ${loaiCuocText}:`} className='col-25 mb10' value={DataDetail.chucNangCuocThanhTraInfo && DataDetail.chucNangCuocThanhTraInfo.text ? DataDetail.chucNangCuocThanhTraInfo.text : ''} />
                  <ShowIf condition={DataDetail.chucNangCuocThanhTra !== 'CHUYEN_NGANH'}>
                    <Text label={`Lĩnh vực ${loaiCuocText}:`} className='col-25 mb10' value={!isEmpty(Data, 'linhVucThanhTraList') ? get(Data, 'linhVucThanhTraList', []).map((item) => item.text).join(', ') : ''} />
                  </ShowIf>
                  <ShowIf condition={DataDetail.chucNangCuocThanhTra === 'CHUYEN_NGANH'}>
                    <Text label={`Hình thức ${loaiCuocText} chuyên ngành:`} className='col-25 mb10' value={Data.hinhThucThanhTraChuyenNganhInfo && Data.hinhThucThanhTraChuyenNganhInfo.text ? Data.hinhThucThanhTraChuyenNganhInfo.text : ''} />
                  </ShowIf>
                  <ShowIf condition={Data.hinhThucThanhTra === 'DOT_XUAT'}>
                    <TextMessage label={`Căn cứ ${loaiCuocText} đột xuất:`} className='col-100 mb10' value={Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : ''} />
                  </ShowIf>
                  {/* <Text label='Đơn vị chủ trì:' className='col-25 mb10' value={Data.donViChuTriInfo ? Data.donViChuTriInfo.ten : ''}/> */}
                </ShowIf>
                {/* <Text label='Đơn vị phối hợp:' className='col-100 mb10' value={Data.donViPhoiHop ? Data.donViPhoiHop : ''}/> */}
                {/* <Text label='Tổng số đơn vị phối hợp:' className='col-100 mb10' value={CountDonViPhoiHop}/> */}
                {/* <Text link label='Đối tượng thanh tra/kiểm tra:' className='col-100 mb10' onClick={this.onOpenDialog.bind(this)} value={tenDoiTuongThanhTraTKH} /> */}
                <Text label={`Tổng số đối tượng ${loaiCuocText}:`} className='col-100 mb10' value={CountDoiTuongThanhTra} />
                <Text label={`Đối tượng ${loaiCuocText} liên quan:`} className='col-100 mb10' value={Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : ''} />
                <Text label={`Tổng số đối tượng ${loaiCuocText} liên quan:`} className='col-100 mb10' value={CountDoiTuongThanhTraLienQuan} />
              </div>
              <section className="wrap-block">
                <div className="row pl10 pr10 heading-addnew-dttt">
                  <h2 className='title-13 col-100 pl20 pr20 mt10 mb15'>1.3 Căn cứ cuộc {loaiCuocText}</h2>
                </div>
                <div className="row pl10 pr10 ">
                  <DataTable
                    header={header.dsCanCuCuocThanhTraView}
                    dataList={Data.danhMucVanBans}
                    hidePagination={true}
                    parent={this}
                  >
                    <RowItemCanCuCuocThanhTraView />
                  </DataTable>
                </div>
              </section>
            </Collapse>
          </section>
          <Collapse className="wrap-collapses" isOpen={this.state.showThongTinThanhTra}>
            {/*end thông tin cuộc thanh tra/kiểm tra*/}
            {/*Thành viên đoàn*/}
            <ShowIf condition={Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' && Data.thanhVienDoan}>
              <div>
                <div className='pl20 pb20 pr20'>
                  <div className='line-border'></div>
                </div>
                <section className='row pl35 pr35 mb10'>
                  <div className='col-100 no-gutter'>
                    <h2 className='title-12 mb10'>{DataDetail.keHoachThanhTraInfo != {} && DataDetail.keHoachThanhTraInfo != null ? "1.2.1 Thành viên đoàn" : '1.1.1 Thành viên đoàn'}</h2>
                    <div className='row pl10 pr10'>
                      <Text label='Số quyết định:' className='col-25 mb0-18' value={Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : ''} />
                      <Text label='Ngày quyết định:' className='col-25 mb0-18' value={Data.ngayRaQuyetDinhThanhLapDoan ? moment(Data.ngayRaQuyetDinhThanhLapDoan).format('DD/MM/YYYY') : ''} />
                    </div>
                    <div className='wrap-table-show-oncheck white-table'>
                      <DataTable
                        header={header.thanhTra.TMTVCTTV}
                        dataList={Data.listThanhVienDoan ? Data.listThanhVienDoan : []}
                        pageData={this.state.pageData}
                        parent={this}
                        hideButtonExport
                        hidePagination={true}
                        search={this.state.search}
                        tableLoading={this.state.tableLoading}>
                        <RowItemChiTietThanhVienCuocThanhTraView linhVucThanhTra={Data.linhVucThanhTra ? Data.linhVucThanhTra : ''} />
                      </DataTable>
                    </div>
                  </div>
                </section>
              </div>
            </ShowIf>
            {/*end Thành viên đoàn*/}
            {/*Gia hạn*/}
            <ShowIf condition={Data.giaHan}>
              <div className='pl20 pb20 pr20'>
                <div className='line-border'></div>
              </div>
              <section className='pl35 pr35 row mb20'>
                <div className='col-100 block-gray p10 pl15 pr15'>
                  <h2 className='txt-12 txt-bold txt-upper pt10 mb15'>Gia hạn</h2>
                  <div className='row pl10 pr10'>
                    <Text className="col-25 mb10" label='Số quyết định:' value={Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : ''} />
                    <Text className="col-25 mb10" label='Ngày ra quyết định:' value={Data.ngayRaQuyetDinhGiaHan ? moment(Data.ngayRaQuyetDinhGiaHan).format('DD/MM/YYYY') : ''} />
                    <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={Data.lyDonGiaHan ? Data.lyDonGiaHan : ''} />
                  </div>
                </div>
              </section>
            </ShowIf>
            {/*end Gia hạn*/}
            <ShowIf condition={true}>
              <div className='row pl35 pr35 pb20'>
                <div className='col-100 block-gray p10'>
                  <div className='row pl20 pr20'>
                    <h2 className='txt-12 txt-bold txt-upper pt10 pb15'>Thông báo kết thúc {loaiCuocText} trực tiếp</h2>
                  </div>
                  <div className='row pl15 pr15'>
                    <div className='col-100 no-gutter'>
                      <Text label='Số thông báo:' className='col-25 mb10' value={Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhThongBaoKetThucTTTT ? moment(Data.ngayBanHanhThongBaoKetThucTTTT).format('DD/MM/YYYY') : ''} />
                      <Text label='Người ban hành:' className='col-25 mb10' value={Data.nguoiBanHanhThongBaoKetThucTTTTInfo ? Data.nguoiBanHanhThongBaoKetThucTTTTInfo.hoVaTen : ''} />
                    </div>
                    <TextMessage label='Ghi chú:' className='col-100' value={Data.ghiChu ? Data.ghiChu : ''} />
                  </div>
                </div>
              </div>
            </ShowIf>
            <ShowIf condition={true}>
              <div>
                <section className='wrap-block pb10'>
                  <div className='row pl15 pr15'>
                    <div className='col-100 no-gutter pl20 pr20 pb20'>
                      <div className='line-border'></div>
                    </div>
                    <h2 className='title-12 p20'>{DataDetail.keHoachThanhTraInfo != {} && DataDetail.keHoachThanhTraInfo != null ? `1.4 Kết luận ${loaiCuocText}` : `1.2 Kết luận ${loaiCuocText}`}</h2>
                  </div>
                  <div className='row pl30 pr30'>
                    <div className='col-100 no-gutter'>
                      <Text label={`Số kết luận ${loaiCuocText}:`} className='col-25 mb10' value={Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhKetLuanThanhTra ? moment(Data.ngayBanHanhKetLuanThanhTra).format('DD/MM/YYYY') : ''} />
                      <Text label='Đơn vị ban hành:' className='col-25 mb10' value={donViBanHanh} />
                    </div>
                    <div className='col-100 no-gutter'>
                      <Text label='Số quyết định xử lý:' className='col-25 mb10' value={Data.soQuyetDinhXuLy ? Data.soQuyetDinhXuLy : ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhQuyetDinhXuLy ? moment(Data.ngayBanHanhQuyetDinhXuLy).format('DD/MM/YYYY') : ''} />
                    </div>
                    <TextMessage label={`Tóm tắt kết luận ${loaiCuocText}:`} className='col-100 mb10' value={Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : ''} />
                  </div>
                </section>
              </div>
            </ShowIf>
          </Collapse>
          <ShowIf condition={true}>
            <div className='pl20 pr20'>
              <div className='wrap-big-line'>
                <div className='big-border'></div>
              </div>

              <h2 className={`collapse-title pt15 pb15 ${this.state.showThongTinTheoDoi ? "collapse-open" : "collapse-close"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showThongTinTheoDoi')}>2. Thông tin theo dõi thực hiện</Link></h2>
              <Collapse className="wrap-collapses" isOpen={this.state.showThongTinTheoDoi}>
                <div className='mb15'>
                  <div className='line-border'></div>
                </div>
                <section className='wrap-block'>
                  <h2 className='title-12 mb10'>2.1. Văn bản chỉ đạo của cấp trên</h2>
                  <div className='row pl10 pr10'>
                    <Text className='col-25 mb10' label='Số văn bản:' value={this.state.soVanBanChiDaoCuaCapTren} />
                    <Text className='col-25 mb10' label='Ngày ban hành:' value={this.state.ngayBanHanhVanBanChiDaoCuaCapTren} />
                    <Text className='col-25 mb10' label='Cơ quan ban hành:' value={donViBanHanhVanBanChiDao} />
                    <TextMessage className='col-100 mb10' label='Ghi chú:' value={this.state.ghiChuVanBanChiDaoCuaCapTren} />
                  </div>
                </section>
                <ShowIf condition={this.state.showFile && DataDetail.tienDoThanhTra != 'LUU_HO_SO'}>
                  <ContainerFileDinhKem
                    labelClass="title-12"
                    label="Danh sách văn bản xử lý"
                    hideDescription={true} disableAttachFile={true}
                    dataShow={this.state.listTaiLieuChiDaoCuaCapTren} />
                </ShowIf>
                <div className='pt10 pb20'>
                  <div className='line-border' />
                </div>
                <section className='wrap-block'>
                  <h2 className='title-12 mb10'>2.2. Văn bản báo cáo kết quả thực hiện kết luận {loaiCuocText}</h2>
                  <div className='row pl10 pr10'>
                    <Text className='col-25 mb10' label='Số văn bản:' value={this.state.soVanBanBaoCaoKetQuaThucHienKetLuanThanhTra} />
                    <Text className='col-25 mb10' label='Ngày ban hành:' value={this.state.ngayBanHanhVanBanBaoCaoKetQuaThucHienKLTT} />
                    <Text className='col-25 mb10' label='Cơ quan ban hành:' value={donViBanHanhVanBanBaoCao} />
                    <TextMessage className='col-100 mb10' label='Ghi chú:' value={this.state.ghiChuBanBaoCaoKetQuaThucHienKetLuanThanhTra} />
                  </div>
                </section>
                <ShowIf condition={this.state.showFile && DataDetail.tienDoThanhTra != 'LUU_HO_SO'}>
                  <ContainerFileDinhKem
                    labelClass="title-12"
                    label="Danh sách văn bản xử lý"
                    hideDescription={true} disableAttachFile={true}
                    dataShow={this.state.listTaiLieuKetQuaThucHienKetLuanThanhTra} />
                </ShowIf>
                <div className='pt10 pb20'>
                  <div className='line-border' />
                </div>
                <section className='wrap-block pb10'>
                  <h2 className='title-12 mb10'>2.3. Kết quả thực hiện kết luận {loaiCuocText}</h2>
                  <div className='row pl15 pr15'>
                    <NoiDungKienNghi view={true} linhVucThanhTra={Data.linhVucThanhTra ? Data.linhVucThanhTra : ''} chucNangCuocThanhTra={Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : ''} listDoiTuongViPham={this.state.listDoiTuongViPham} onRef={noiDungKienNghi => (this.noiDungKienNghi = noiDungKienNghi)} type={this.state.type} id={this.state.id} />
                  </div>
                </section>
                <ShowIf condition={this.state.showFile}>
                  <ContainerFileDinhKem
                    labelClass="title-12"
                    label="2.4. Danh sách văn bản xử lý"
                    hideDescription={true} disableAttachFile={true}
                    dataShow={this.state.listTaiLieuXuLyCuocThanhTra} />
                </ShowIf>
              </Collapse>
            </div>
          </ShowIf>
        </div>

        <div className="action-form-wrap pt35 pb5">
          <div className="box-bottom">
            <Link className="btn-action btn-close" onClick={this.onClickClose.bind(this, 'close')}><span>Đóng</span></Link>
          </div>
        </div>
        <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={DataDetail} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this)} />
      </div>
    );
  }
}

KetQuaTheoDoiThucHien.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'DOT_XUAT'
}

export default KetQuaTheoDoiThucHien;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/KetQuaTheoDoiThucHien.jsx